/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are exp, iat, and nbf?`)
};

const es_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué son exp, iat y nbf?`)
};

const de_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeuten exp, iat und nbf?`)
};

const nl_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat zijn exp, iat en nbf?`)
};

const fr_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que sont exp, iat et nbf ?`)
};

const it_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa sono exp, iat e nbf?`)
};

const pt_br2_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que são exp, iat e nbf?`)
};

const pt_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que são exp, iat e nbf?`)
};

const ja_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exp、iat、nbfとは何ですか？`)
};

const zh_jw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exp、iat 和 nbf 分别是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_faq2_q", locale)
	if (locale === "en") return en_jw_faq2_q(inputs)
	if (locale === "es") return es_jw_faq2_q(inputs)
	if (locale === "de") return de_jw_faq2_q(inputs)
	if (locale === "nl") return nl_jw_faq2_q(inputs)
	if (locale === "fr") return fr_jw_faq2_q(inputs)
	if (locale === "it") return it_jw_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_jw_faq2_q(inputs)
	if (locale === "pt") return pt_jw_faq2_q(inputs)
	if (locale === "ja") return ja_jw_faq2_q(inputs)
	return zh_jw_faq2_q(inputs)
};